var _rect, _path, _path2, _rect2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentEmpty = function SvgDocumentEmpty(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 27,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-2875 -2185C-2875 -2240.23 -2830.23 -2285 -2775 -2285H24649C24704.2 -2285 24749 -2240.23 24749 -2185V3320C24749 3375.23 24704.2 3420 24649 3420H-2775C-2830.23 3420 -2875 3375.23 -2875 3320V-2185Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-2775 -2284H24649V-2286H-2775V-2284ZM24748 -2185V3320H24750V-2185H24748ZM24649 3419H-2775V3421H24649V3419ZM-2874 3320V-2185H-2876V3320H-2874ZM-2775 3419C-2829.68 3419 -2874 3374.68 -2874 3320H-2876C-2876 3375.78 -2830.78 3421 -2775 3421V3419ZM24748 3320C24748 3374.68 24703.7 3419 24649 3419V3421C24704.8 3421 24750 3375.78 24750 3320H24748ZM24649 -2284C24703.7 -2284 24748 -2239.68 24748 -2185H24750C24750 -2240.78 24704.8 -2286 24649 -2286V-2284ZM-2775 -2286C-2830.78 -2286 -2876 -2240.78 -2876 -2185H-2874C-2874 -2239.68 -2829.68 -2284 -2775 -2284V-2286Z",
    fill: "white",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 493,
    transform: "translate(-238 -124)",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5714 1H3.66667C2.19391 1 1 2.19391 1 3.66667V23.3333C1 24.8061 2.19391 26 3.66667 26H18.3333C19.8061 26 21 24.8061 21 23.3333V7.87128",
    stroke: "#B5B3B0",
    strokeDasharray: "4 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6667 7.29283H16.5541C15.6959 7.29283 15 6.59 15 5.72264V0C15.1866 0.085104 15.3578 0.204168 15.5051 0.352986L21.3177 6.78372C21.465 6.93249 21.5824 7.10483 21.6667 7.29283Z",
    fill: "#B5B3B0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentEmpty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "document-empty.f47bfc4048b5aeb577f558e77acc2629.svg";